import { RegisterForm } from './register-form';
import { AuthLayout } from './auth-layout';
import Link from 'next/link';
import { AuthSeparator } from './auth-separator';
import { SocialSignIn } from './social-sign-in';
import { Description } from '@snapi/luxury';

export function RegisterPage() {
  return (
    <AuthLayout>
      {(emailSent) => (
        <div className="flex flex-1 justify-center">
          <div className="flex flex-1 flex-col gap-8 max-w-[300px]">
            <h2 className="text-center">Welcome!</h2>
            <div className="flex self-center max-w-[280px]">
              <RegisterForm onRegister={emailSent} />
            </div>
            <span className="text-center">
              <Description>
                If you have an account
                <br className="sm:hidden" /> you can&nbsp;
                <Link href="/auth/login">
                  <a className="underline">log in</a>
                </Link>
              </Description>
            </span>
            <AuthSeparator />
            <SocialSignIn />
          </div>
        </div>
      )}
    </AuthLayout>
  );
}
